import { render, staticRenderFns } from "./IWLSWDWC.vue?vue&type=template&id=65efc318&scoped=true"
import script from "./IWLSWDWC.vue?vue&type=script&lang=js"
export * from "./IWLSWDWC.vue?vue&type=script&lang=js"
import style0 from "./IWLSWDWC.vue?vue&type=style&index=0&id=65efc318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efc318",
  null
  
)

export default component.exports